import {styled} from "@mui/material/styles"
import {Typography, TypographyProps} from "@mui/material"
import Grid from "@mui/material/Grid"
import {HTMLAttributes} from "react"

const ColoredTypography = styled(({color, ...props}: {color: string} & TypographyProps) => <Typography {...props} />)`
	color: ${(props) => props.color};
`

const ColoredTypographyWithBottomMargin = styled(ColoredTypography)`
	margin-bottom: 2px;
`

const GridWithPadding = styled(Grid)`
	padding-left: ${(props) => props.theme.spacing(4)};
	padding-right: ${(props) => props.theme.spacing(4)};

	@media (min-width: 440px) {
		padding-left: ${(props) => props.theme.spacing(10)};
		padding-right: ${(props) => props.theme.spacing(10)};
	}
`

const BulletList = styled(({color, ...p}: {color: string} & HTMLAttributes<HTMLUListElement>) => <ul {...p} />)`
	margin-bottom: 10px;
	padding: 0 16px;
	font-size: 14px;
	line-height: 20px;
	color: ${(props) => props.color};
`

export {GridWithPadding, ColoredTypographyWithBottomMargin, BulletList}
